import { Component, OnInit, ViewChild, ElementRef, inject, model } from '@angular/core';
import { ENTER } from '@angular/cdk/keycodes';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent, MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { BookService } from 'src/app/services/book.service';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Observable, startWith, map, debounceTime } from 'rxjs';

@Component({
  selector: 'kbm-narrator-chips',
  templateUrl: './narrator-chips.component.html',
  styleUrls: ['./narrator-chips.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    MatChipsModule, 
    MatAutocompleteModule, 
    MatOptionModule, 
    MatIconModule, 
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule
  ],
})
export class NarratorChipsComponent implements OnInit {
  @ViewChild('auto') matAutocomplete!: MatAutocomplete;
  @ViewChild('narratorInput') narratorInput!: ElementRef<HTMLInputElement>;

  narrators = model.required<string[]>();

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;

  separatorKeysCodes = [
    ENTER
  ];

  narratorCtrl = new UntypedFormControl();

  allNarrators: string[] = []

  filteredNames!: Observable<string[]>;


  bookService = inject(BookService);

  ngOnInit(): void {
    this.loadNarrators();
    this.filteredNames = this.narratorCtrl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(300),
        map((value: any) => this._filter(value || '')),
      );

  }

  async loadNarrators() {
    try {
      const narratorList = await this.bookService.getNarratorList();
      this.allNarrators = narratorList.map(a => a.narrator);
    }
    catch (err) {
      console.error(err);
    }
  }

  add(evt: MatChipInputEvent): void {
    const value = (evt.value || '').trim();
    // Add our narrator
    if (value) {
      this.narrators().push(value);
    };
    // Clear input value
    evt.chipInput!.clear();
    this.narratorInput.nativeElement.value = '';
    this.narratorCtrl.setValue(null);

  }

  remove(narrator: string): void {
    const index = this.narrators().indexOf(narrator);

    if (index >= 0) {
      this.narrators().splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.narrators) {
      this.narrators().push(event.option.viewValue);
    } else {
      console.log('Huh, no narrators to start');
    };
    this.narratorInput.nativeElement.value = '';
    this.narratorCtrl.setValue(null);
  }

  private _filter(name: string): string[] {
    const filterValue = name.toLowerCase();
    return this.allNarrators.filter(
      (entry) => entry.toLowerCase().includes(filterValue)
    );
  }
}

